<button *ngFor="let button of buttonText; let e = index" (click)="navegar(button.urlredirect)" type="button"
   [ngClass]="{'btn-primary' : button.class == 'primary',
         'btn-success' : button.class == 'success', 'btn-info' : button.class == 'info', 'btn-warning' : button.class == 'warning',
         'btn-danger' : button.class == 'danger'}"
    class="btn btn-sm animate__animated animate__backInRight">
  <i *ngIf="button.iconClass" [ngClass]="button.iconClass" aria-hidden="true"></i>
  <span>&nbsp;{{button.title}}</span>
</button>
